import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Props from './ContinueCheckoutBannerComponent';
import SelectLanguage from './SelectLanguage';

const tabletBreakpoint = '768';

class ContinueCheckoutBanner extends Component<Props> {

    state = {
      parentScreenWidth: window?.parent?.innerWidth,
    };

    onWindowResize = () => {
      this.setState({
        parentScreenWidth: window?.parent?.innerWidth,
      });
    };

    componentDidMount() {
      if (this.props.isDynamicListing) {
        window?.parent.addEventListener('resize', this.onWindowResize);
      }
    }

    componentWillUnmount() {
      window?.parent.removeEventListener('resize', this.onWindowResize);
    }

    shouldShow = () => {
      if (this.props.isDynamicListing) {
        return true;
      }
      return this.props.showCartPill && (this.props.itemCount > 0 || this.props.forceShow);
    }

    render() {

      let pillClass = 'checkout__cart-pill';
      if (this.props.isDynamicListing) {
        pillClass += ' checkout__cart-pill-dynamic-listing';
      }

      const mainClassName = this.props.isDynamicListing && this.state?.parentScreenWidth >= tabletBreakpoint
        ? 'checkout__bar checkout__bar--with-margin'
        : 'checkout__bar';
      
      return (
        <div className={mainClassName}>
          <SelectLanguage className='select-language--listing' />
          {this.shouldShow() && (
            <button className={pillClass} onClick={this.props.showCart}>
              {this.props.timeRemaining !== '00:00' &&
                <span className="checkout__cart-pill__timer">
                  <i className="icon-clock" />
                  <span className="checkout__cart-pill__timer-time" aria-live='polite'>
                    {this.props.timeRemaining}
                  </span>
                </span>
              }
              <span className="checkout__cart-pill__items">
                <i className="icon-shopping_cart" />
                {+this.props.itemCount > 0 && (
                  <span className="checkout__cart-pill__items-count">
                    {this.props.itemCount}
                  </span>
                )}
              </span>
            </button>
          )}
        </div>
      )
    }
}

ContinueCheckoutBanner.propTypes = {
    showCart: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired
}

export default ContinueCheckoutBanner
